import { Component, Input, OnInit, SimpleChanges } from '@angular/core';
import { ManagementMenu } from '../../core/models/menu/management-menu';
import { StorageService } from '../../core/services/storage.service';
import { NavigationEnd, Router } from '@angular/router';

@Component({
    selector: 'tab',
    templateUrl: './tab.component.html',
    styleUrls: ['./tab.component.scss'],
    standalone: false
})
export class TabComponent implements OnInit {
  @Input() tabs: ManagementMenu[] = [];

  selected: string[] = [];

  constructor(
    private router: Router,
    public storageService: StorageService,
  ) {}

  ngOnInit() {
    this.selectTab(this.router.url.split('?')[0]);

    this.router.events.subscribe((event) => {
      if (event instanceof NavigationEnd) {
        this.selected = [];
        this.selectTab(this.router.url.split('?')[0]);
      }
    });
  }

  changeTab(route: string[]) {
    this.selected = route;
  }

  selectTab(currentUrl: string) {
    let lastUrl = this.tabs?.find((t) => {
      return t.route.join('/') === currentUrl;
    });

    if (lastUrl) this.selected = lastUrl.route;
  }
}
